export default "__VITE_ASSET__DmKDwM0o__"